'use client';
import Breadcrumbs from '@/components/common/Breadcrumbs';
import AppImage from '@/components/ui/AppImage';
import CountUp from 'react-countup';

interface RegionalHeroProps {
  className?: string;
}

const RegionalHero = ({ className = '' }: RegionalHeroProps) => {
  return (
    <section
      data-header="dark"
      className={`relative bg-gradient-to-r from-green-900 to-black bg-[length:200%_200%] animate-gradient-x text-white overflow-hidden ${className}`}
    >
      <div className="absolute inset-0 opacity-10">
        <AppImage
          src="https://images.unsplash.com/photo-1523805009345-7448845a9e53"
          alt="Aerial view of Nairobi cityscape with modern skyscrapers and green spaces showing urban development"
          fill
          className="object-cover"
          priority
        />
      </div>

      <div className="relative container mx-auto px-4 py-8  lg:py-32">
        <div className="max-w-7xl mt-8">
          <Breadcrumbs className="mb-2 sm:mb-4" />
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-1 sm:py-2 rounded-full mb-2 sm:mb-4 md:mb-6">
            <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
            <span className="font-body text-sm font-medium text-accent">
              Kenya Flagship Operations
            </span>
          </div>

          <h1 className="font-headline text-3xl md:text-5xl lg:text-6xl font-semibold mb-2 sm:mb-8 leading-tight">
            Building <span className="text-accent">Africa's Economic Future</span> Through <span className="text-accent">Strategic Regional Partnerships</span>
          </h1>

          <p className="font-body text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed mb-2 sm:mb-12  max-w-3xl">
            Our Kenya flagship model demonstrates systematic, scalable approaches to sustainable
            development. Through authentic government partnerships and local collaboration, we're
            creating replicable frameworks for regional economic transformation.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-2 sm:mt-4 ">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-6 border border-white/20">
              <div className="text-3xl font-headline font-semibold text-accent mb-2">
                <CountUp end={5} duration={10} decimals={0} />+
              </div>
              <div className="font-body text-sm text-gray-200">Active Regional Partnerships</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-headline font-semibold text-accent mb-2">
                <CountUp end={12} duration={10} decimals={0} />
              </div>
              <div className="font-body text-sm text-gray-200">Counties Engaged</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-headline font-semibold text-accent mb-2">
                KES <CountUp end={2.4} duration={10} decimals={1} />B
              </div>
              <div className="font-body text-sm text-gray-200">Local Investment Committed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionalHero;
